<style scoped>
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
        /*margin-right: 5px;*/
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="输入关键字搜索供应商"
          @on-enter="doSearch()"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_payee_company_path"
        :params="params"
        type="search"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <div class="line">
      <Table
        size="small"
        :columns="columns"
        :data="payee_companies"
        :loading="loading"
      />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/fin/recharge_write_off">
  import Util from '../../libs/util';
  import fin_base from './mixins/fin_base';
  import RechargeWriteOffExpand from './components/recharge_write_off_expand';
  export default {
    /* router_info_start */
    router_info: '/fin/recharge_write_off',
    /* router_info_end */

    mixins: [fin_base],
    data() {
      return {
        get_payee_company_path: Util.api.query_recharge_payee_companies,
        params: {
          search: '',
          page: 1,
          per_page: 10
        },
        loading: false,
        columns: [
          // {
          //     title: '展开',
          //     type: 'expand',
          //     align: 'center',
          //     width: 50,
          //     render: (h, params) => {
          //         return h(RechargeWriteOffExpand, {
          //             props: {
          //                 payee_company: params.row,
          //                 inherit_expense_types: this.expense_types,
          //                 inherit_expense_type_hash: this.expense_type_hash,
          //             }
          //         })
          //     }
          // },
          {
            title: '供应商',
            key: 'name',
            align: 'center'
          },
          {
            title: '总充值金额',
            key: 'recharge_sum',
            align: 'center',
            render: (h, params) => {
              return (h('span', Util.formatPrice(params.row.recharge_sum)));
            }
          },
          {
            title: '已冲销金额',
            key: 'write_off_sum',
            align: 'center',
            render: (h, params) => {
              return (h('span', Util.formatPrice(params.row.write_off_sum)));
            }
          },
          // {
          //     title: '已冲销金额-old',
          //     key: 'write_off_sum',
          //     align: 'center',
          //     render: (h, params)=>{
          //         return (h('span', Util.formatPrice(params.row.write_off_sum_old)));
          //     }
          // },
          {
            title: '剩余金额',
            align: 'center',
            render: (h, params) => {
              const left = math.eval(`${params.row.recharge_sum} - ${params.row.write_off_sum}`).toFixed(2);
              return (h('span', Util.formatPrice(left)));
            }
          },
        ],
        payee_companies: [],
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        }
      }
    },
    computed: {
      //
    },
    created() {
      this.getExpenseTypes();
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(false);
      },
      doSearch() {
        this.params.page = 1;
        this.loading = true;
        this.$refs.searchBtn.doAjax();
      },
      handleData(data) {
        this.loading = false;
        this.payee_companies = [];
        data.payee_companies.forEach((pc) => {
          this.payee_companies.push(pc);
        });
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({
          title: '错误',
          content: e.message
        });
      }
    }
  }
</script>
